import makeApi from "../../libs/axios/api";

const apiPromise = makeApi();
const id = 0;

const ADD_PATH = `/configuration?id=${id}`;

export const getConfigurationDetails = async (): Promise<any> => {
  const api = await apiPromise;
  return api.get(ADD_PATH).then((response) => {
    return response.data;
  });
};
